<div class="modal-header">
  <h4 class="modal-title">{{qas?.title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <div class="message">
    <h3><strong>{{qas?.introduction}}</strong></h3>
    <p>{{ qas?.step1 }}</p>
    <p>{{ qas?.step2 }}</p>
    <p>{{ qas?.step3 }}</p>
  </div>

</div>
<div class="modal-footer text-center">
</div>
